import $ from 'jquery';
import init from './init';

$(init);



// WEBPACK FOOTER //
// ./app/scripts/app.js